<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Temporary Autonomous Bureau</p>
      </b-col>
    </b-row>



    <b-row>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Installation, discussion, workshop, performance, publication</p>
      <p>The Temporary Autonomous Bureau is a space for researching and discussing interpretations of autonomy in cultural or social projects within Rotterdam. For the duration of three months in 2018, we converted a space at TENT into a temporary office. Following two projects from 2017 – the database ‘The Autonomous Archive’ and the publication ‘A Bed, a Chair and a Table’ – we used this space to carry on researching Poortgebouw’s story, a historic residential community located next to the Maas River.</p>
      <p>The project has 3 parts. First, we organized a discussion session with guests from WORM Pirate Bay Archive, Leeszaal West and Stichting Freehouse, on the topic of <a href="https://www.tentrotterdam.nl/event/the-temporary-autonomous-bureau-anomalous-institutions/" target="_blank"><i>Anomalous Institutions</i></a> and how they can function and survive in Rotterdam. Second, within the workshop <a href="https://www.tentrotterdam.nl/event/workshop-stop-being-an-instrument-and-sing-your-own-songs/" target="_blank"><i>Stop Being an Instrument and Sing Your Own Songs</i></a>, we generated slogans with the help of a Python script, painted them on banners and displayed them in and outside of the TENT building. Finally, during our last performance <a href="https://www.tentrotterdam.nl/event/the-temporary-autonomous-bureau-anatomy-autonomy/" target="_blank"><i>Anatomy of Autonomy</i></a>, we read collectively a computer generated manifesto on autonomy and self-organization, and presented our research within a publication. </p>
      <p>This research project was developed together with Angeliki Diakrousi, Giulia de Giovanelli, Naomi De Wit, Philippa Driest, and Thanos Kaltsamis. Find this project <a href="https://www.tentrotterdam.nl/tentoonstelling/rotterdam-cultural-histories-13-the-temporary-autonomous-bureau/" target="_blank">here</a> as well.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/tab/installation.jpg"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/tab/read.JPG"></b-img>
      </b-col>

      <b-col md="4">
      <b-img class="img-fluid" src="media/tab/IMG_0793.JPG"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/tab/code.png"></b-img>
      </b-col>
    </b-row>

    <b-row class="content">
      <b-col md="4">
        <b-img class="img-fluid" src="media/tab/zine.JPG"></b-img>
      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/tab/scan.jpg"></b-img>
      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/tab/scan2.jpg"></b-img>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'TabPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
